import { motion } from 'motion/react';

type TrustpilotScoreProps = {
    id?: string;
    theme?: 'dark' | 'light';
};

export default function TrustpilotScore({
    id = 'trustpilot-score',
    theme = 'dark',
}: TrustpilotScoreProps) {
    return (
        <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 100, height: 'auto' }}
            transition={{ delay: 1 }}
        >
            <div
                id={id}
                title='Trustpilot Score'
                className='trustpilot-widget'
                data-locale='en-GB'
                data-template-id='5613c9cde69ddc09340c6beb'
                data-businessunit-id='567dd08a0000ff000586fa46'
                data-style-height='30px'
                data-style-width='100%'
                data-theme={theme}
                data-token='562aceba-9510-4da8-ab09-c2ac8656e99c'
                data-font-family='Work Sans'
            >
                <a
                    href='https://uk.trustpilot.com/review/airporttaxis-uk.co.uk'
                    target='_blank'
                    rel='noopener'
                >
                    Trustpilot
                </a>
            </div>
        </motion.div>
    );
}
